import React from "react";
import { render } from "react-dom";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import swal from 'sweetalert';
import $ from "jquery";
import PrivateRoute from "./PrivateRoute";

import Home from "./Home";
import Privacy from "./Privacy";
import Terms from "./Terms";
import Login from "./auth/Login";
import Register from "./auth/Register";

import Dashboard from "./Dashboard";
import Evest from "./Evest";
import Landvest from "./Landvest";
import Plans from "./Plans";
import Transactions from "./Transactions";
import Referrals from "./Referrals";
import Profile from "./Profile";
import SingleHome from "./SingleHome";
import SingleLand from "./SingleLand";

// Admin Pages

import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/Dashboard";
import UsersList from "./admin/Users";
import UserPlans from "./admin/UserPlans";
import UserDetails from "./admin/UserDetails";
import AdminProfile from "./admin/Profile";

import EvestList from "./admin/EvestList";
import EditHome from "./admin/EditHome";
import NewHome from "./admin/NewHome";

import LandvestList from "./admin/LandvestList";
import EditLand from "./admin/EditLand";
import NewLand from "./admin/NewLand";


// Define App URL
axios.defaults.baseURL = 'https://api.evest.ng/api/v1';
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api/v1';
// axios.defaults.baseURL = 'http://172.20.10.2:8000/api/v1';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      user: {}
    };
  }
  _loginAdmin = (email, password) => {
    $("#login-form button")
      .attr("disabled", "disabled")
      .html(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span class="sr-only">Loading...</span>'
      );
    var formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${axios.defaults.baseURL}/admin-login`, formData)
      .then(response => {
        //console.log(response);
        return response;
      })
      .then(json => {
        if (json.data.success) {
          // alert(json.data.message);
          swal("Success!", json.data.message, "success", {
            button: false,
            timer: 1500
          });
          const { id, fname, lname, email, phone } = json.data.user;
          const { token } = json.data.token;

          let userData = {
            id,
            fname,
            lname,
            email,
            phone,
            token,
            timestamp: new Date().toString()
          };
          let appState = {
            isLoggedIn: true,
            user: userData
          };
          // save app state with user date in local storage
          localStorage["appState"] = JSON.stringify(appState);
          this.setState({
            isLoggedIn: appState.isLoggedIn,
            user: appState.user,
            token: appState.token
          });
          // redirect home
          this.props.history.push("/admin/dashboard");
        } else swal("Error!", json.data.message, "error");
        ;

        $("#login-form button")
          .removeAttr("disabled")
          .html("Login");
      })
      .catch(error => {
        // alert(`An Error Occured! ${error}`);
        swal("Login Failed!", "" + error.response.data.message, "error", {
          button: false,
          timer: 1500
        });
        $("#login-form button")
          .removeAttr("disabled")
          .html("Login");
      });
  };

  _loginUser = (email, password) => {
    $("#login-form button")
      .attr("disabled", "disabled")
      .html(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span class="sr-only">Loading...</span>'
      );
    var formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${axios.defaults.baseURL}/login`, formData)
      .then(response => {
        //console.log(response);
        return response;
      })
      .then(json => {
        if (json.data.success) {
          // alert(json.data.message);
          swal("Success!", json.data.message, "success", {
            button: false,
            timer: 1500
          });
          const { id, fname, lname, email, phone } = json.data.user;
          const { token } = json.data.token;

          let userData = {
            id,
            fname,
            lname,
            email,
            phone,
            token,
            timestamp: new Date().toString()
          };
          let appState = {
            isLoggedIn: true,
            user: userData
          };
          // save app state with user date in local storage
          localStorage["appState"] = JSON.stringify(appState);
          this.setState({
            isLoggedIn: appState.isLoggedIn,
            user: appState.user,
            token: appState.token
          });
          // redirect home
          this.props.history.push("/dashboard");
        } else swal("Error!", json.data.message, "error");
        ;

        $("#login-form button")
          .removeAttr("disabled")
          .html("Login");
      })
      .catch(error => {
        // alert(`An Error Occured! ${error}`);
        swal("Login Failed!", "" + error.response.data.message, "error", {
          button: false,
          timer: 1500
        });
        $("#login-form button")
          .removeAttr("disabled")
          .html("Login");
      });
  };

  _registerUser = (fname, lname, remail, phone, rpassword, ref_url) => {
    $("#reg button")
      .attr("disabled", "disabled")
      .html(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span class="sr-only">Loading...</span>'
      );

    var formData = new FormData();
    formData.append("fname", fname);
    formData.append("lname", lname);
    formData.append("email", remail);
    formData.append("phone", phone);
    formData.append("password", rpassword);
    formData.append("ref_url", ref_url);

    axios
      .post(`${axios.defaults.baseURL}/register`, formData)
      .then(response => {
        //console.log(response);
        return response;
      })
      .then(json => {
        if (json.data.success) {
          // alert(`Registration Successful!`);
          swal("Success!", json.data.message, "success", {
            button: false,
            timer: 1500
          });
          const { id, fname, lname, email, phone } = json.data.user;
          const { token } = json.data.token;
          let userData = {
            id,
            fname,
            lname,
            email,
            phone,
            token,
            timestamp: new Date().toString()
          };
          let appState = {
            isLoggedIn: true,
            user: userData
          };
          // save app state with user date in local storage
          localStorage["appState"] = JSON.stringify(appState);
          this.setState({
            isLoggedIn: appState.isLoggedIn,
            user: appState.user,
            token: appState.token
          });
          // redirect home
          this.props.history.push("/dashboard");
        } else {
          // alert(`Registration Failed!`);
          swal("Failed", "Registration Failed", "error");
          $("#reg button")
            .removeAttr("disabled")
            .html("Register");
        }
      })
      .catch(error => {
        // alert("An Error Occured!" + error);
        let res = ((error.response.data.message.fname || "")  + (error.response.data.message.lname || "")  + (error.response.data.message.email || "") + (error.response.data.message.phone || "")  + (error.response.data.message.password || ""));
        swal("Error!", "" + res, "error", {
          button: false,
          // timer: 1500
        });
        //console.log(error);
        $("#reg button")
          .removeAttr("disabled")
          .html("Register");
      });
  };

  render() {
    return (
          <Switch data="data">
            <div id="main">
                  <Route exact path="/" component={Home}/>
                  <Route exact path="/privacy" component={Privacy}/>
                  <Route exact path="/terms" component={Terms}/>

                  <Route exact path="/login" component={props => <Login {...props} loginUser={this._loginUser} />}/>
                  <Route path="/register" component={props => <Register {...props} registerUser={this._registerUser} />}/>

                  <PrivateRoute exact path="/dashboard" component={props => (<Dashboard {...props}/>)}/>
                  <PrivateRoute exact path="/evest" component={props => (<Evest {...props}/>)}/>
                  <PrivateRoute exact path="/landvest" component={props => (<Landvest {...props}/>)}/>
                  <PrivateRoute exact path="/my-plans" component={props => (<Plans {...props}/>)}/>
                  <PrivateRoute exact path="/my-transactions" component={props => (<Transactions {...props}/>)}/>
                  <PrivateRoute exact path="/referrals" component={props => (<Referrals {...props}/>)}/>
                  <PrivateRoute exact path="/my-account" component={Profile}/>
                  <PrivateRoute path="/view-home" component={props => (<SingleHome {...props}/>)}/>
                  <PrivateRoute path="/view-land" component={props => (<SingleLand {...props}/>)}/>

                  {/* Admin Routes */}
                  <Route exact path="/admin" component={props => <AdminLogin {...props} loginAdmin={this._loginAdmin} />}/>
                  <PrivateRoute exact path="/admin/dashboard" component={props => (<AdminDashboard {...props}/>)}/>
                  <PrivateRoute exact path="/admin/my-account" component={props => (<AdminProfile {...props}/>)}/>

                  <PrivateRoute exact path="/admin/users-list" component={props => (<UsersList {...props}/>)}/>
                  <PrivateRoute path="/admin/user-details" component={props => (<UserDetails {...props}/>)}/>
                  <PrivateRoute path="/admin/user-plans" component={props => (<UserPlans {...props}/>)}/>

                  <PrivateRoute exact path="/admin/evest-list" component={props => (<EvestList {...props}/>)}/>
                  <PrivateRoute path="/admin/new-home" component={props => (<NewHome {...props}/>)}/>
                  <PrivateRoute path="/admin/edit-home" component={props => (<EditHome {...props}/>)}/>

                  <PrivateRoute exact path="/admin/landvest-list" component={props => (<LandvestList {...props}/>)}/>
                  <PrivateRoute path="/admin/new-land" component={props => (<NewLand {...props}/>)}/>
                  <PrivateRoute path="/admin/edit-land" component={props => (<EditLand {...props}/>)}/>

            </div>
          </Switch>
    );
  }
}

const AppContainer = withRouter(props => <App {...props} />);
// //console.log(store.getState())
render(
  <BrowserRouter>
    <AppContainer />
  </BrowserRouter>,

  document.getElementById("root")
);
